__turbopack_context__.v({
  "mainArticle": "InsightExecSumPage-module__VkUPjG__mainArticle",
  "pageBackground": "InsightExecSumPage-module__VkUPjG__pageBackground",
  "typeLabel": "InsightExecSumPage-module__VkUPjG__typeLabel",
});
